import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const DeleteDialog = props => {
  const { classes, title, itemToDelete, openDialog, okButtonName='Ok', cancelButtonName=null, doneButtonName=null, onConfirm, onCancel=null, onDone=null } = props;

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Found {itemToDelete.sharedDocumentCount} document(s) shared with this shared user.  Are you sure you want to remove {itemToDelete.firstName} {itemToDelete.lastName} ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {okButtonName &&
            // <Button onClick= {onConfirm}>
            <Button onClick = {() => {
              onConfirm(itemToDelete);
            }}>
              {okButtonName}
            </Button>
          }
          {cancelButtonName &&
            <Button onClick={onCancel} autoFocus>
              {cancelButtonName}
            </Button>
          }
          {doneButtonName &&
            <Button onClick={onDone} autoFocus>
              {doneButtonName}
            </Button>
          }
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DeleteDialog;
